import React, { useEffect, useState } from "react";
import DTOResignationARModal from "./DTOResignationARModal";
import ResignationARModalPresenter from "./ResignationARModalPresenter";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import {
  setAllClaimList,
  setAllClaimListLoader,
} from "../../../../infra/aggregates/myProfile/claimAggregates/claimListSlice";
import { claimService } from "../../../../api/services/claimService";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import {
  setAllClaimHistory,
  setClaimTicketLoader,
} from "../../../../infra/aggregates/myProfile/claimAggregates/claimHistorySlice";
import { setAllAirTicketHistory } from "../../../../infra/aggregates/myProfile/claimAggregates/airTicketHistorySlice";
import { actionRequiredService } from "../../../../api/services/actionRequiredService";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  fullData: any;
  historyData: any;
}

const ResignationARModalController = ({
  isModalOpen,
  closeModal,
  fullData,
  historyData,
}: ModalInterface) => {
  const selector = useAppSelector((state) => state.authSlice);
  const [allActions, setAllActions] = useState([]);
  const { t } = useTranslation();

  const getDaAction = (data: any) => {
    setAllActions(data);
  };

  const hitAction = (payload: any) => {
    actionRequiredService
      .finalActionSubmitActionRequired(payload)
      .then((res: any) => {
        if (res?.response == "success") {
          toast.success("Action Performed Successfully!");
          closeModal();
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.data);
      });
  };
  return (
    <div>
      <DTOResignationARModal setAllActions={getDaAction} />

      <ResignationARModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trans={t}
        fullData={fullData}
        historyData={historyData}
        allActions={allActions}
        userId={selector.user_id}
        handleSubmitAR_Request={hitAction}
      />
    </div>
  );
};

export default ResignationARModalController;
